var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm._isCheckout
    ? _c(
        "div",
        { staticClass: "header", class: _vm.style() },
        [
          _c("header-placeholder"),
          _vm._v(" "),
          _c("mq-layout", { attrs: { mq: "desktop" } }, [_c("navigation")], 1),
          _vm._v(" "),
          _c(
            "mq-layout",
            { attrs: { mq: ["mobile", "tablet"] } },
            [
              _c("app-header-navigation"),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade-down" } },
                [_vm.hasItems() ? _c("header-checkout-bar") : _vm._e()],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "header", class: _vm.style() },
        [
          _vm.$mq !== "desktop" ? _c("app-header-navigation") : _vm._e(),
          _vm._v(" "),
          _vm.$mq === "desktop" ? _c("checkout-header") : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1519e11b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1519e11b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/AppHeader/AppHeader.vue
// module id = null
// module chunks = 